(function($) {
  $(document).ready(function() {
    const $customerJourney = $(".customer-journey");
    if ($customerJourney.length) {
      initClickableCircles($customerJourney);
      initCircles($customerJourney);
      initSmallCircles($customerJourney);
    }
  });

  // Initialize the state of every clickable circle.
  const initClickableCircles = $customerJourney => {
    $customerJourney.find(".clickable").each(function() {
      const $clickableCircle = $(this);
      $clickableCircle.on("click", function() {
        $clickableCircle.attr("data-active")
          ? $clickableCircle.removeAttr("data-active")
          : $clickableCircle.attr("data-active", true);
      });
    });
  };

  // Align the circle label on load and window resize.
  // Also toggle and align the circle content on click.
  const initCircles = $customerJourney => {
    $customerJourney.find(".circle").each(function() {
      const $circle = $(this);
      const circleIndex = $circle.attr("data-index");
      const $circlePulse = $customerJourney.find(`.circle-pulse[data-index="${circleIndex}"]`);
      const $circleContent = $customerJourney.find(`.circle-content[data-index="${circleIndex}"]`);
      const $label = $circleContent.find(".circle-label");
      const $list = $circleContent.find(".circle-list");
      const $reference = $customerJourney.find(".svg-wrapper");

      // Manage the hover and active state.
      $circle.on("click", function() {
        $list.add($circlePulse).toggleClass("active");
      });

      $circle.hover(
        function() {
          $list.addClass("hover");
        },
        function() {
          $list.removeClass("hover");
        }
      );
      $circle.focus(
        function () {
          $list.addClass("hover");
        }
      );
      $circle.blur(
        function () {
          $list.removeClass("hover");
        }
      );

      const $staticCircle = $circle.find("circle");

      // Position the elements related to the circle on window load and resize.
      const alignContent = Drupal.debounce(() => {
        const staticCircleRect = $staticCircle[0].getBoundingClientRect();
        const referenceRect = $reference[0].getBoundingClientRect();

        const circleWidth = staticCircleRect.width;
        const circleHeight = staticCircleRect.height;
        const circleTop = staticCircleRect.top - referenceRect.top;
        const circleLeft = staticCircleRect.left - referenceRect.left;

        $circlePulse.css({
          width: circleWidth,
          height: circleHeight,
          top: circleTop,
          left: circleLeft
        });


        $circleContent.css({
          top: circleTop,
          left: circleLeft
        });

        $label.css({
          width: circleWidth,
          height: circleHeight
        });

        const buffer = ($list.height() - circleHeight) / 2;
        $list.css({
          "margin-top": `${-buffer}px`
        });

        $label.removeClass("hidden");
      });

      alignContent();
      $(window).on('resize', alignContent);
    });
  };

  // Toggle the label on click.
  // Also align the label on window resize.
  const initSmallCircles = $customerJourney => {
    $customerJourney.find(".small-circle").each(function() {
      const $circle = $(this);
      const circleIndex = $circle.attr("data-index");
      const $label = $customerJourney.find(
        `.small-circle-label[data-index="${circleIndex}"]`
      );
      const $reference = $customerJourney.find(".svg-wrapper");

      $circle.on("click", function() {
        $label.toggleClass("active");
      });

      $circle.hover(
        function() {
          $label.addClass("hover");
        },
        function() {
          $label.removeClass("hover");
        }
      );

      const alignLabel = Drupal.debounce(() => {
        $label.css({
          top: $circle.offset().top - $reference.offset().top - 1,
          left:
            $circle.offset().left - $reference.offset().left - $label.width()
        });
      });

      alignLabel();
      $(window).on('resize', alignLabel);
      });
    }
})(jQuery);
